interface DmSegmentedOption<T extends string> {
    value: T;
    label: string;
}

interface DmSegmentedProps<T extends string> {
    options: readonly DmSegmentedOption<T>[];
    value: T;
    onChange: (value: T) => void;
    disabled?: boolean;
}

export function DmSegmented<T extends string>({
    options,
    value,
    onChange,
    disabled
}: DmSegmentedProps<T>) {
    return (
        <div className="flex items-center gap-0.5 rounded-md bg-gray-100 p-0.5 h-9">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    disabled={disabled}
                    aria-pressed={option.value === value}
                    onClick={() => onChange(option.value)}
                    className={`flex-1 h-full rounded text-[13px] font-semibold transition-colors disabled:opacity-50 ${
                        option.value === value
                            ? 'bg-white text-gray-900 shadow-sm'
                            : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
